import { getPolicyName } from '../../utils/fns';

export const updatePolicyStatusInCache = (
  oldData: any,
  policyId: string,
  newStatus: number
) => {
  if (!oldData?.data) return oldData;

  const updatedRawData = oldData.data.map((policy: any) =>
    policy.policyUuid === policyId
      ? { ...policy, policyRealtimeEnabled: newStatus }
      : policy
  );

  return {
    ...oldData,
    data: updatedRawData,
  };
};

export const updatePolicyPriorityInCache = (
  oldData: any,
  policyId: string,
  newPriority: number
) => {
  if (!oldData?.data) return oldData;

  const rawData = [...oldData.data];

  const draggedIndex = rawData.findIndex((p) => p.policyUuid === policyId);
  if (draggedIndex === -1) return oldData;

  const draggedItem = rawData[draggedIndex];
  const draggedPolicyTypeName = getPolicyName(
    draggedItem.policyType,
    draggedItem.policySubType
  );

  // Only reorder policies of the same type
  const [removed] = rawData.splice(draggedIndex, 1);

  // There should always exist another policy with the target priority
  const targetIndex = rawData.findIndex(
    (p) =>
      p.policyPriority === newPriority &&
      getPolicyName(p.policyType, p.policySubType) === draggedPolicyTypeName
  );

  // Shift index depending on if we moved it up or down
  if (removed.policyPriority < newPriority) {
    rawData.splice(targetIndex + 1, 0, removed);
  } else {
    rawData.splice(targetIndex, 0, removed);
  }

  // Only update priorities for policies of the same type
  const updatedRawData = rawData.map((policy) => {
    if (
      getPolicyName(policy.policyType, policy.policySubType) !==
      draggedPolicyTypeName
    ) {
      return policy; // Keep other policy types unchanged
    }

    // Find the new index among policies of the same type
    const sameTypePolicies = rawData.filter(
      (p) =>
        getPolicyName(p.policyType, p.policySubType) === draggedPolicyTypeName
    );
    const indexInType = sameTypePolicies.findIndex(
      (p) => p.policyUuid === policy.policyUuid
    );

    return {
      ...policy,
      policyPriority: indexInType + 1,
    };
  });

  return {
    ...oldData,
    data: updatedRawData,
  };
};
